import React from 'react';
import HelpCopy from '../HelpCopy';

export default () => (
  <div className="modal-help">
    <HelpCopy />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Modal/Help.js